<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Dados Vitais</h1>
    <div v-if="this.vital_datas().length == 0">Nenhum registro de dados vitais do paciente</div>
    <div class="mb-8" v-for="(vital_data, vital_data_index) in this.vital_datas()">
        <div class="flex justify-between bg-gray-100 p-4 font-semibold">
          <div>
            {{ vital_data.question }}
          </div>
          <div>
              <font-awesome-icon v-if="expanded(vital_data.id)" @click.prevent="collapse(vital_data.id)" icon="fa-square-minus" class="text-gray-500 text-lg cursor-pointer" />
              <font-awesome-icon v-if="!expanded(vital_data.id)" @click.prevent="expand(vital_data.id)" icon="fa-square-plus" class="text-gray-500 text-lg cursor-pointer" />
          </div>
        </div>
        <div v-if="expanded(vital_data.id)" class="flex flex-nowrap" v-for="(vital_data_answer, vital_data_answer_index) in vital_data.answers">
          <div class="w-2/3 lg:w-1/2 p-4">
            {{ vital_data_answer.text }}
          </div>
          <div class="w-1/3 lg:w-1/2 p-4">
            {{ vital_data_answer.value }}
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
  inject: ['patient', 'vital_datas'],
  components: {
    
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      expandeds: []
    }
  },
  methods: {
    expanded(id) {
      return this.expandeds.indexOf(id) >= 0;
    },
    collapse(id) {
      let i = this.expandeds.indexOf(id);
      if(i >= 0) {
        this.expandeds.splice(i, 1);
      }
    },
    expand(id) {
      this.expandeds.push(id);
    }
  },
  mounted() {

  },
}
</script>